import { CreateAccountRequest, CreateAccountResponse } from '../../common/types';
import apiClient from '../apiClient';

export const createNewAccount = async (createAccountRequest: CreateAccountRequest) => {
	try {
		const formattedDob = `${createAccountRequest.dob.day}/${createAccountRequest.dob.month}/${createAccountRequest.dob.year}`;
		const transformedItems = createAccountRequest.items.map((item) => ({
			brand_code: item.brandCode,
			size_label: item.sizeLabel,
			type_label_long: item.typeLabelLong,
			firestore_id: item.firestoreId,
			fitting_code: 0, // ✅ default hardcoded
		}));
		console.debug('[CreateNewAccount] Request payload:', transformedItems);
		const response: CreateAccountResponse = await apiClient(`/users/create_account/`, {
			method: 'POST',
			body: JSON.stringify({
				email: createAccountRequest.email,
				dob: formattedDob,
				gender: createAccountRequest.shoppingPreference,
				style: createAccountRequest.fashionStyle,
				items: transformedItems,
				uid: createAccountRequest.uid || '',
			}),
		});

		/*if (!response || response.status_code !== 201) {
			throw new Error(`Failed to create account`);
		}*/

		return {
			status_code: response.status_code,
			uid: response.uid,
			custom_token: response.custom_token,
		};
	} catch (error) {
		console.error('Error:', JSON.stringify(error, null, 2));
		throw Error(`Failed to create account`);
	}
};
